import { Breakpoints, BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { AsyncPipe, NgClass, NgIf, NgStyle } from '@angular/common';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { getUrlPathWithSuffix, pathNames } from '../../utilities/routing-path-utils';
import { LoginRequest } from '../../models/requests/login-request';
import { AuthenticationService } from '../../services/authentication.service';
import { localStoragevarNames as localStorageVarNames } from '../../utilities/local-storage-utils';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppComponentEventsService } from '../../events/app-component-events.service';
import { UserStatus } from '../../models/enums/user-status';
import { environment } from '../../environments/environments';
import { resetUserInLocalStorage } from '../../utilities/user-utils';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    AsyncPipe,
    NgStyle,
    MatProgressSpinnerModule,
    NgIf,
    RouterLink,
    NgClass
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent {
  hide: boolean = true;
  isLoginLoading: boolean = false;
  loginForm!: FormGroup;
  lostPasswordPath: string = getUrlPathWithSuffix(pathNames.lostPasswordPath);
  signUpPath: string = getUrlPathWithSuffix(pathNames.signUpPath);
  desktopQuery: MediaQueryList;
  mobileQuery: MediaQueryList;

  private _queryListener: () => void; 

  constructor(
    private snackBar: MatSnackBar, 
    private formBuilder: FormBuilder, 
    private authService: AuthenticationService, 
    private router: Router, 
    private appComponentEventService: AppComponentEventsService,
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher
  ) { 
    this.desktopQuery = media.matchMedia('(min-width: 1100px)');
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._queryListener = () => changeDetectorRef.detectChanges();
    this.desktopQuery.addEventListener('change', this._queryListener);
    this.mobileQuery.addEventListener('change', this._queryListener);
  }

  ngOnInit() {
    this.initForm();
  }

  ngOnDestroy(){
    this.desktopQuery.removeEventListener('change', this._queryListener);
    this.mobileQuery.removeEventListener('change', this._queryListener);
  }

  initForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }


  onGoogleLogin() {
    window.open(`${environment.baseUrl}/auth/google`, "_self");
  }

  onSubmit() {
    this.isLoginLoading = true;

    if (this.loginForm.valid) {
      const formValues = this.loginForm.value;

      const loginRequest: LoginRequest = {
        username: formValues['email'],
        password: formValues['password']
      };

      this.authService.login(loginRequest).subscribe({
        next: (user) => {
          if (user.userStatus == UserStatus.PENDING_APPROVAL.toString()) {
            this.router.navigate([`/${pathNames.validateAccountPath}/${user.email}`]);
            return;
          }

          localStorage.setItem(localStorageVarNames.userLogged, 'true');
          resetUserInLocalStorage(user);
          this.isLoginLoading = false;
          this.router.navigate(['/' + pathNames.aiAgentConfigurationPath]);
          this.appComponentEventService.onUserLogInEvent.emit(true);
        },
        error: (error) => {
          console.log(error);

          this.isLoginLoading = false;
          this.snackBar.open('Error wrong credentials', 'Close', { duration: 5000 });
        }
      });
    }
  }

  getF(): { [key: string]: AbstractControl<any, any> } {
    return this.loginForm.controls;
  }
}
